<p-fieldset [legend]="legend" *ngIf="address" fieldsetAriaFix>
  <div class="row">
    <div class="col-12">
      {{streetNumberAndName}}
    </div>
    <div class="col-12">
      {{cityAndProvince}}
    </div>
    <div class="col-12">
      {{poBoxAndPostalCode}}
    </div>    
    <div class="col-12" *ngIf="address.country">
      {{'COMMON.countryList.'+address.country | translate}}
    </div>
  </div>
</p-fieldset>
